<div class="row col-12">
  <div class="col-6 c-drag-list__container">
    <div class="mb-10">
      <p500-ui-select-field
        i18n-label="@@common.allowed_offers"
        label="Allowed Offers"
        [data]="allowedData$"
        [formControl]="form.controls.allowed"
        className="affiliate-offer-access-select"
        multiple="true"
      ></p500-ui-select-field>
    </div>

    <div
      class="drag__list"
      cdkDropList
      #allowedList="cdkDropList"
      [cdkDropListData]="allowedListArr"
      [cdkDropListConnectedTo]="[deniedList]"
      (cdkDropListDropped)="drop($event)"
      [hidden]="!(allowedListArr.length || deniedListArr.length)"
    >
      <div class="c-drag-list__item d-flex justify-content-between" *ngFor="let item of allowedListArr; index as i" cdkDrag>
        <span>{{ item.name }}</span>
        <div *rbac="RbacPermissionsConstant.COMMANDS_OFFER_ACCESS_DETACH" class="d-flex justify-content-end">
          <button p500-ui-button-icon transparent="true" color="warn" (click)="remove(i, allowedListArr)">
            <p500-ui-icon name="bin" size="16px"></p500-ui-icon>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-6 c-drag-list__container">
    <div class="mb-10">
      <p500-ui-select-field
        i18n-label="@@common.denied_offers"
        label="Denied Offers"
        [data]="deniedData$"
        [formControl]="form.controls.denied"
        className="affiliate-offer-access-select"
        multiple="true"
      ></p500-ui-select-field>
    </div>

    <div
      class="drag__list"
      cdkDropList
      #deniedList="cdkDropList"
      [cdkDropListData]="deniedListArr"
      [cdkDropListConnectedTo]="[allowedList]"
      (cdkDropListDropped)="drop($event)"
      [hidden]="!(allowedListArr.length || deniedListArr.length)"
    >
      <div class="c-drag-list__item d-flex justify-content-between" *ngFor="let item of deniedListArr; index as i" cdkDrag>
        <span>{{ item.name }}</span>
        <div *rbac="RbacPermissionsConstant.COMMANDS_OFFER_ACCESS_DETACH" class="d-flex justify-content-end">
          <button p500-ui-button-icon transparent="true" color="warn" (click)="remove(i, deniedListArr)">
            <p500-ui-icon name="bin" size="16px"></p500-ui-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
